import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const DocumentProjectFileWidget = lazy(() => import('.'))

declare global {
  interface HTMLElementTagNameMap {
    'document-project-file-widget': DocumentProjectFileWidgetComponent
  }
}

class DocumentProjectFileWidgetComponent extends ReactWebComponent {
  static get observedAttributes() {
    return []
  }

  override render() {
    return (
      <RootProviders>
        <DocumentProjectFileWidget />
      </RootProviders>
    )
  }
}

customElements.define('document-project-file-widget', DocumentProjectFileWidgetComponent)
